/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Playdata_BlurbInputs */

const ja_home_brands_playdata_blurb = /** @type {(inputs: Home_Brands_Playdata_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国内eスポーツ大会の視聴データを多角的に分析し、同時視聴者数の動向や他ゲームとの比較をレポートにします。`)
};

const en_home_brands_playdata_blurb = /** @type {(inputs: Home_Brands_Playdata_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics service to measure esports and streaming performance so you can make better decisions when working with games.`)
};

/**
* | output |
* | --- |
* | "Analytics service to measure esports and streaming performance so you can make better decisions when working with games." |
*
* @param {Home_Brands_Playdata_BlurbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_playdata_blurb = /** @type {((inputs?: Home_Brands_Playdata_BlurbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Playdata_BlurbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_playdata_blurb(inputs)
	return en_home_brands_playdata_blurb(inputs)
});